import { ServiceResponse } from "~/api/api.types";
import { ResourceGroup } from "~/shared.types";
import { api } from "./axios";

export const getResources = async () => {
  const response =
    await api.get<ServiceResponse<ResourceGroup[]>>(`/resources`);

  return response.data;
};
